const Status = {
    PURCHASE_ORDER_PROBLEM: 'c5ac1758-edc1-11e0-ac38-e811324a6a81',
    PURCHASE_ORDER_FOLLOW_UP: 'a31ff30c-954c-11e1-bf6a-1231392238ea',
    PURCHASE_ORDER_CREATED: '888e165d-ce8f-4977-bbe3-d8364937b127',
    PURCHASE_ORDER_SUBMITTED: 'a4cb57e2-edc1-11e0-ac38-e811324a6a81',
    PURCHASE_ORDER_CONFIRMED: 'b5eb2e8a-edc1-11e0-ac38-e811324a6a81',
    PURCHASE_ORDER_SHIPPED: '08d4a0aa-edc6-11e0-ac38-e811324a6a81',
    PURCHASE_ORDER_READY_FOR_BILLING: 'adbe0dd6-ee11-11e0-ac38-e811324a6a81',
    PURCHASE_ORDER_CLOSED: 'e964a285-b34a-11e2-90f5-e811324a6a81',
    PURCHASE_ORDER_BILLED: '33eabdd4-bbfc-48e0-8010-b59ddf620889',

    SALES_ORDER_NEW: '4c9d3727-a5cb-4d62-ab42-82ae9b5238fb',
    SALES_ORDER_PENDING_CLIENT_APPROVAL: '07f49459-99d7-40c2-ba68-7066a11d76cc',
    SALES_ORDER_CLIENT_CHANGE_REQUESTED: '53b40d53-3dda-4e7e-8a64-6f44c136f96c',
    SALES_ORDER_CLIENT_APPROVED: '16ee0574-75ae-47ca-b2c7-d441bc8f19a1',
    SALES_ORDER_IN_PRODUCTION: '8224599d-d6d6-40b4-be96-84403ea6b2ee',
    SALES_ORDER_SHIPPED: '3d1be487-7195-41b6-8c57-82e4663c36d2',
    SALES_ORDER_READY_TO_BE_INVOICED: '0328ee19-22a8-4774-a75a-75fd66f08044',
    SALES_ORDER_INVOICED: '1e4731d9-85f6-47b1-bc1b-b03be041ed85',
    SALES_ORDER_CLOSED: 'b05b061a-2463-11e1-83be-1231392503bd',

    INVOICE_OPEN: '11a8be26-95a3-4572-ac02-798d5b52f246',
    INVOICE_SENT_TO_CLIENT: '6c41260f-df3a-11eb-8989-0a51afecc89b',
    INVOICE_EXPORTED: '413824bd-85b2-4e69-87b5-72ce1d9964c0',
    INVOICE_PAID: '502140ba-f44e-447d-ae7a-2889492872d7',
    INVOICE_PARTIALLY_REFUNDED: 'd424b985-2475-428e-ac2e-9dc846a4a505',
    INVOICE_REFUNDED: 'e93c96b2-15cf-4806-afc2-2dfd819c8230',

    CREDIT_MEMO_OPEN: '375206a3-7cf2-11ef-8427-0ad1674602e7',
    CREDIT_MEMO_EXPORTED: '37a492e6-7cf2-11ef-8427-0ad1674602e7',

    VENDOR_CREDIT_OPEN: '36093b20-7cf2-11ef-8427-0ad1674602e7',
    VENDOR_CREDIT_EXPORTED: '36ba6af0-7cf2-11ef-8427-0ad1674602e7',

    // Split Ship Status
    SPLIT_SHIP_OPEN: 'c53a8f27-0eb4-4ec2-8d65-714c5fd071da',
    SPLIT_SHIP_READY_FOR_CSV: '6c9e9a18-6df3-4f8e-b9ae-a37877017fc2',
    SPLIT_SHIP_PROCESSING_CSV: '2e5636c7-e723-4ad6-a9d5-5c1765d1cb39',
    SPLIT_SHIP_CSV_ERROR: '66911a1f-2021-4298-ae5b-cd6aa5d9005d',
    SPLIT_SHIP_READY_FOR_TAX: 'f87d96fc-7941-44f9-91a1-338f8066abca',
    SPLIT_SHIP_CALCULATING_TAX: '509963a2-be2d-4047-a9b8-802959d5fb34',
    SPLIT_SHIP_TAX_ERROR: 'f4da0127-75e7-44bd-9762-9a76abf9bd6f',
    SPLIT_SHIP_COMPLETED: 'd05c8449-a5b6-4eb3-aa10-2df4d2d4a8c9',
    SPLIT_SHIP_CLOSED: 'cba88385-1a60-4a0b-97bb-dd436b15b5d5',
};

export default Status;
